import React, { useCallback, useState } from 'react'
import type { ReactNode } from 'react'
import { Overlay, Popover } from 'react-bootstrap'
import { useKey } from 'react-use'
import { TaskTooltipPopOverProvider } from './Context'
import { Body } from './Body'

export type UseTaskTooltipPopOverResult = {
  tooltipElement: ReactNode
  openTooltip: (taskId: string, anchorEl: HTMLElement) => void
  closeTooltip: () => void
}

export const useTaskTooltipPopOver = ({ canEdit = true }: { canEdit?: boolean } = {}): UseTaskTooltipPopOverResult => {
  const [activeTaskId, setActiveTaskId] = useState<string | null>(null)
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const [show, setShow] = useState(false)

  const openTooltip = useCallback((taskId: string, anchor: HTMLElement) => {
    setActiveTaskId(taskId)
    setAnchorEl(anchor)
    setShow(true)
  }, [])

  const closeTooltip = useCallback(() => {
    setShow(false)
    setActiveTaskId(null)
    setAnchorEl(null)
  }, [])

  useKey('Escape', closeTooltip, undefined, [show])

  const tooltipElement =
    show && activeTaskId ? (
      <Overlay show={show} target={anchorEl} placement="auto" rootClose onHide={closeTooltip}>
        <Popover id="task-tooltip-popover" className="fw-normal shadow-lg">
          <Popover.Body className="p-2">
            <TaskTooltipPopOverProvider taskId={activeTaskId} canEdit={canEdit}>
              <Body />
            </TaskTooltipPopOverProvider>
          </Popover.Body>
        </Popover>
      </Overlay>
    ) : null

  return { tooltipElement, openTooltip, closeTooltip }
}
